import { MBrandElementProps } from '../MBrandElement/MBrandElement.types';
import { MTextBlockFullProps } from '../MTextBlockFull/MTextBlockFull.types';
import { MButtonProps } from '../MButton/MButton.types';

export enum MContentBlockAlignment {
  Left = 'Left',
  Centered = 'Centered',
}

/** AEM dialog checkbox: boolean or serialized `"true"` / `"false"`. */
export type MContentBlockFlag = 'true' | 'false' | boolean;

export interface MContentBlockProps extends React.HTMLAttributes<HTMLDivElement> {
  alignment?: MContentBlockAlignment;
  /**
   * Controls brand element visibility. When false, hides `mBrandElement`
   * even if the model still includes it. Defaults to shown when
   * `mBrandElement` is authored.
   */
  showBrandElement?: MContentBlockFlag;
  /** AEM `buttonGroup`. When true, renders `mButton` (and optionally `mButton2`). */
  buttonGroup?: MContentBlockFlag;
  /**
   * Figma `secondaryButton`. Only applies when `buttonGroup` is on. When false,
   * hides `mButton2`. When omitted, `mButton2` still renders if authored (AEM).
   */
  secondaryButton?: MContentBlockFlag;
  mBrandElement?: MBrandElementProps;
  mTextBlockFull?: MTextBlockFullProps;
  mButton?: MButtonProps;
  mButton2?: MButtonProps;
  className?: string;
}
